<template>
  <div class="grid grid-cols max-w-[1144px] max-w-176 w-full items-start self-stretch gap-4">
    <FormStepInputs
      :step="{
        stepName: name,
        formInputs: content,
      }"
    >
      <template #actionBar>
        <ActionBar
          v-if="filteredFields"
          v-bind="filteredFields"
          :outerClass="actionBarContent.outerClass"
          :innerClass="actionBarContent.innerClass"
          :handleLinkClickEvent="true"
          @btnClick="(linkName) => onClick_ActionBarButton(linkName)"
        ></ActionBar>
      </template>
    </FormStepInputs>
  </div>
  <MembershipCardModal ref="membershipCardModalModalEl" :membershipCardModal="physicalCardStore.membershipCardModal" />
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import ActionBar from '@/components/ActionBar/ActionBar.vue';
import { getFormInput } from '@/utils/form-input-helper';
import MembershipCardModal from '@/components/MembershipCard/MembershipCardModal.vue';
import { useSelfServicePhysicalMembershipCardStore } from '@/store';

const membershipCardModalModalEl = ref<InstanceType<typeof MembershipCardModal>>();
const physicalCardStore = useSelfServicePhysicalMembershipCardStore();

const props = defineProps<{
  content: ISitecoreFormGenericInput[];
  id: string;
  name: string;
}>();

enum AllActionButtons {
  btnViewCard = 'btnViewCard',
  btnAddToWallet = 'btnAddToWallet',
}

const platform = computed(() => {
  const ua = navigator.userAgent || navigator.vendor;
  const isAndroid = /android/i.test(ua);
  const isApple = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
  return isAndroid ? 'android' : isApple ? 'apple' : 'unsupported';
});

const actionBarContent = getFormInput(props.content, 'actionBar');

const filteredFields = computed(() => {
  const validActionButtons = [AllActionButtons.btnViewCard];

  if (platform.value !== 'unsupported') {
    validActionButtons.push(AllActionButtons.btnAddToWallet);
  }

  const tempFilteredFields = {
    fields: actionBarContent.fields.filter((x: any) => validActionButtons.includes(x.name)),
  };

  return tempFilteredFields;
});

const onClick_ActionBarButton = async (linkItem: any) => {
  switch (linkItem.name) {
    case AllActionButtons.btnViewCard:
    case AllActionButtons.btnAddToWallet:
      if (!membershipCardModalModalEl?.value) return;
      membershipCardModalModalEl?.value.showModal();
      break;
  }
};
</script>
